const SCROLL_TOLERANCE = 2;

export const initTableScroll = () => {
  const containers = [...document.querySelectorAll(".js-table-scroll")];

  if (containers.length === 0) {
    return;
  }

  const update = (container) => {
    const viewport = container.querySelector(".js-table-scroll-viewport");

    if (!viewport) {
      return;
    }

    const isScrollable =
      viewport.scrollWidth - viewport.clientWidth > SCROLL_TOLERANCE;
    const isAtEnd =
      viewport.scrollLeft + viewport.clientWidth >=
      viewport.scrollWidth - SCROLL_TOLERANCE;
    const hintId = viewport.dataset.scrollHintId;

    container.classList.toggle("is-scrollable", isScrollable);
    container.classList.toggle("is-at-end", !isScrollable || isAtEnd);

    if (isScrollable) {
      viewport.tabIndex = 0;
      viewport.setAttribute("aria-describedby", hintId);
    } else {
      viewport.removeAttribute("tabindex");
      viewport.removeAttribute("aria-describedby");
    }
  };

  for (const container of containers) {
    const viewport = container.querySelector(".js-table-scroll-viewport");

    if (!viewport) {
      continue;
    }

    update(container);

    viewport.addEventListener(
      "scroll",
      () => {
        if (Math.abs(viewport.scrollLeft) > SCROLL_TOLERANCE) {
          container.classList.add("is-interacted");
        }

        update(container);
      },
      { passive: true },
    );
  }

  let resizeFrame;
  window.addEventListener(
    "resize",
    () => {
      window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(() => {
        for (const container of containers) {
          update(container);
        }
      });
    },
    { passive: true },
  );

  window.addEventListener("load", () => {
    for (const container of containers) {
      update(container);
    }
  });
};
